import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { MatSlider } from '@angular/material/slider';
import { DomSanitizer } from '@angular/platform-browser';
import mixpanel from 'mixpanel-browser';
import { AppState } from '../app.service';
import { CordovaService } from '../cordova.service';
import { Option } from '../option/option.model';
import { Path } from '../path/path-v2.model';
import { Poll, PollStats } from '../poll/poll.model';
import { PollService } from '../poll/poll.service';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { User } from '../user/user.model';
import { expandOnEnterAnimation, slideInDownAnimation } from 'angular-animations';
import { HomeUiService } from '../new-design/home-ui.service';
import { I18n } from '../i18n.service';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

// export interface MatRangeSliderChange<T> {
//   value: T;
// }
@Component({
  selector: 'first90-linear-scale',
  templateUrl: './linear-scale.component.html',
  styleUrls: ['./linear-scale.component.scss'],
  animations:[
    expandOnEnterAnimation({ duration: 400 }),
    slideInDownAnimation({duration:300}),
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ],


})
export class LinearScaleComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() parentComponentName: string;
  @Input() poll
  @Input() isPreview: boolean
  @Input() inverted = false
  @Output() blurCard= new EventEmitter<any>();
  @Output() scaleEvent = new EventEmitter<any>();
  @Input() enable= false;
  @Input() pathAverage;
  @Input() progressItems = [];
  @Input() currentIndex = 0;
  @Input() screenId: any;
  @Input() chapterIndex: number;
  @Input() stepIndex: number
  @Input() animationClass: boolean = false;
  @ViewChild('slider') slider: MatSlider;
  @ViewChildren('questionRef') questionRefs: QueryList<ElementRef>;
  enabled = true // TODO: Get it from the path
  nameTQ: string // TODO: Get it from the path
  nameHYPA: string // TODO: Get it from the path
  path: Path
  stats: PollStats
  status: string
  chart = []
  loading: boolean = false;
  statsPer: number[]
  currentUser: User
  enableFinal: boolean =false;
  lowerScale: number
  isMobileWebIos = false;
  isMobileWeb=false;
  higherScale: number
  scaleValue: number
  answerList: any
  linearScale = 0
  isMobile: boolean
  innerQuestionHtml: any;
  constructor(
    private pollService: PollService,
    private appState: AppState,
    private cordovaService: CordovaService,
    public tostrService: ToasterService,
    private i18n: I18n,
    private cdRef: ChangeDetectorRef,// LUMBA-1308
    public homeUIService: HomeUiService,
    private render: Renderer2,
    private _sanitizer: DomSanitizer,
  ) {
    this.currentUser = this.appState.get('currentUser')
    this.path = this.appState.get('currentPath')
    // this.isEnabled()
    // this.initNames()
    this.isMobile = this.appState.get('isMobile')
  }

  ngOnInit() {
    this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(this.poll?.screen?.content?.question ?? '');
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.loading = false;
    // if (this.poll && this.poll.isCompleted) {
    //   this.stats = this.poll.answer.stats
    // }
    if (this.poll?.screen?.content?.lowerScale && this.poll?.screen?.content?.higherScale || this.poll?.screen?.content?.lowerScale == 0) {
      this.lowerScale = this.poll?.screen?.content?.lowerScale
      this.higherScale = this.poll?.screen?.content?.higherScale
    }else{
      this.lowerScale = 1
      this.higherScale = 10
    }
    

    if (this.poll?.screen?.isCompleted || this.poll?.screen?.userResponse ) {
      this.linearScale = this.poll?.screen?.userResponse?.linearScaleRating
      this.pathAverage = this.poll?.screen?.userResponse?.pathAverage;
      // this.getScaleAnswers(this.currentUser.id,this.path.id,this.poll.id)
    } else {
      // Restore from client-side AppState cache (API refetch wipes unsaved slider value)
      const cached = this.appState.get('linearScaleSelections')?.[this.poll?.screenContentId];
      if (cached != null) {
        this.scaleValue = cached;
        this.linearScale = cached;
        this.enableFinal = true;
      }
    }
  //  if(this.poll?.screen?.content?.ptype =='linear') {
  //   this.getScaleAnswers(this.currentUser.id,this.path.id,this.poll.id)
  //  }
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  ngAfterViewInit() {
    this.questionRefs.changes.subscribe(() => {
      setTimeout(() => this.changeSubTextFont());
    });
    this.changeSubTextFont();
  }
  enableBlur() {
    this.enable=!this.enable;
   // if(this.enable)
   let value,scale, pathAverage ;
   value =this.linearScale?.toString()
   scale=this.higherScale.toString()
   pathAverage=this.pathAverage;
      this.blurCard?.emit({
        enable: this.enable,
        linearScale: value,
        pathAverage: pathAverage,
        poll: this.poll
      })
      
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['poll']) {
      this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(this.poll?.screen?.content?.question ?? '');
      setTimeout(() => this.changeSubTextFont());
    }
    if (!changes['poll'] || changes['poll'].firstChange) { return false }
  }


  private isEnabled() {
    this.enabled = this.path.enabledAttributes['polls']
  }

  private initNames() {
    this.nameTQ = this.path.getCustomText('p_tq')
    this.nameHYPA = this.path.getCustomText('p_hypa')
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        console.log('cordova click')
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
  }

  onInputChange(event) {
    this.scaleValue = event?.target ? event?.target.value : event?.value;
    console.log("on input chnge", this.scaleValue, event.value)
    this.enableFinal = true;
    // Persist so it survives getStepDetails refetch on step close/reopen
    const selections = this.appState.get('linearScaleSelections') ?? {};
    selections[this.poll?.screenContentId] = this.scaleValue;
    this.appState.set('linearScaleSelections', selections);
  } 
  
  onTouchMove(event: TouchEvent, slider: MatSlider) {
    const touch = event.touches[0];
    if (slider) {
      this.scaleValue = this.calculateValue(touch.clientX);
      console.log("slider value and posittion on touchmove", this.scaleValue)
      this.enableFinal = true;
      this.cdRef.detectChanges();
    }
  }

  onTouchEnd(event) {
   const touch = event.changedTouches;
    if (touch?.length > 0) {
      this.scaleValue = this.calculateValue(touch[0]?.clientX)
      this.cdRef.detectChanges();
      // Persist so it survives getStepDetails refetch on step close/reopen
      const selections = this.appState.get('linearScaleSelections') ?? {};
      selections[this.poll?.screenContentId] = this.scaleValue;
      this.appState.set('linearScaleSelections', selections);
   }

  console.log("Slider Stopped at:",event, this.scaleValue);
}

// function to calculate slider value from touch position
calculateValue(clientX: number): number {
  const min = this.lowerScale;
  const max = this.higherScale;
  const percentage = clientX / window.innerWidth;
  return Math.round(min + percentage * (max - min));
  
}
  finalize(){
    this.poll.screen.content.isCompleted = true;
    console.log("on input chnge", this.scaleValue)
    this.enableFinal = false;
    this.enable = true;
    const linearSelections = this.appState.get('linearScaleSelections') ?? {};
    delete linearSelections[this.poll?.screenContentId];
    this.appState.set('linearScaleSelections', linearSelections);
    mixpanel.track('linear scale event value', {'value': this.scaleValue})
    this.setScale(this.poll, this.higherScale);
    
  }

  getScaleAnswers(userId: number, pathId: number, questionId: number){
    const requestData = {
      'user_id': userId,
      'path_id': pathId,
      'linear_question_id': questionId
    }

    if(!requestData){
      // this.spinnerService.off();
    }else{
      this.pollService.getLinearScaleAnswers(requestData).subscribe(
        (response) => {
          this.answerList = response.data
          for (let linear of this.answerList ) {
            this.linearScale = linear.linear_rank.linear_rating;
            this.pathAverage =linear.path_average;
            localStorage.setItem('pathAverage',linear.path_average)
          }
          this.cdRef.detectChanges()
        },
        (error) => {
          this.tostrService.error(this.i18n.t('Something went wrong..! Try Again'))
        }
      )
    }
  }

  changeSubTextFont() {
    this.questionRefs?.forEach(ref => {
      if (ref?.nativeElement) {
        this.applyStylesToAllInnerTags(ref.nativeElement);
      }
    });
  }

 applyStylesToAllInnerTags(element: HTMLElement) {
  if (!element) { return; }
  const childElements = Array.from(element.children);
  childElements.forEach((childElement: Element) => {
    const tagName = childElement.tagName.toLowerCase();

    if (tagName === 'ol' || tagName === 'ul') {
      this.render.setStyle(childElement, 'list-style', 'none');
      this.render.setStyle(childElement, 'padding-left', '1.5em');
    }

    if (tagName === 'li') {
      const dataList = childElement.getAttribute('data-list');

      if (dataList === 'bullet') {
        this.render.setStyle(childElement, 'list-style-type', 'disc');
        this.render.setStyle(childElement, 'display', 'list-item');
        this.render.setStyle(childElement, 'list-style-position', 'outside');
      } else if (dataList === 'ordered') {
        this.render.setStyle(childElement, 'list-style-type', 'decimal');
        this.render.setStyle(childElement, 'display', 'list-item');
        this.render.setStyle(childElement, 'list-style-position', 'outside');
      }
    }

    this.applyStylesToAllInnerTags(childElement as HTMLElement);
  });
}

  setScale(poll,higherScale?) {
    const requestData = {
      step_id:poll?.stepId,
      screen_id:poll?.screenId,
      screen_content_id: poll?.screenContentId,
      // option_id:[0],
      linear_scale_rating: this.scaleValue
    }

    if (requestData) {
      this.pollService.savePollAnswersforKyper(requestData).subscribe(
        (response) => {
          let responseData = response.data
          this.pathAverage = responseData?.pathAverage;
          this.appState.set('rankOptionData', response.data)
          poll.screen.isCompleted = true
          let path = this.appState.get('currentPath')
          let stepScreens = path?.kyperChapters?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents
          if (stepScreens) {
          stepScreens.isCompleted = true;
           if(!stepScreens.userResponse){
            stepScreens.userResponse={}
          }
          stepScreens.userResponse.linearScaleRating = responseData?.linearScaleRating
          stepScreens.userResponse.pathAverage = this.pathAverage;
        }
          
          let dailyStepsData = this.appState.get('DailyStepsData');
          let dailyStepScreens = dailyStepsData?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents;
           if (dailyStepScreens) {
          dailyStepScreens.isCompleted = true;
          if(!dailyStepScreens.userResponse){
            dailyStepScreens.userResponse={}
          }
          dailyStepScreens.userResponse.linearScaleRating = responseData?.linearScaleRating
          dailyStepScreens.userResponse.pathAverage = this.pathAverage;
        }
          this.appState.set('DailyStepsData', dailyStepsData);
          this.appState.set('currentPath', path)
          if(!this.poll.screen.userResponse){
            this.poll.screen.userResponse={}
          }
          this.poll.screen.userResponse.linearScaleRating = responseData?.linearScaleRating
          this.poll.screen.userResponse.pathAverage = this.pathAverage;
          this.scaleEvent.emit(
            {
              scaleValue: this.scaleValue.toString(),
              question: this.poll,
              higherScale: this.higherScale.toString(),
              pathAverage: this.pathAverage
            });
        },
        (error) => {
          this.tostrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
        }
      )
    }
  }

}
